// reducer for Notification

import {
  GET_NOTIFICATION_OPEN_LIST,
  GET_NOTIFICATION_OPEN_LIST_SUCCESS,
  GET_NOTIFICATION_OPEN_LIST_ERROR,
  SYSTEM_NOTIFICATION_INTERNAL_SEND,
  SYSTEM_NOTIFICATION_INTERNAL_SEND_SUCCESS,
  SYSTEM_NOTIFICATION_INTERNAL_SEND_ERROR,
} from "./actionType";

const INIT_STATE = {
  notificationOpenList: [],
  notificationOpenListLoading: false,

  // system notification internal send
  systemNotificationInternalSend: [],
  systemNotificationInternalSendLoading: false,
};

const Notification = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_NOTIFICATION_OPEN_LIST:
      return {
        ...state,
        notificationOpenList: action.payload,
        notificationOpenListLoading: true,
      };
    case GET_NOTIFICATION_OPEN_LIST_SUCCESS:
      return {
        ...state,
        notificationOpenListLoading: false,
        notificationOpenList: action.payload,
      };
    case GET_NOTIFICATION_OPEN_LIST_ERROR:
      return {
        ...state,
        notificationOpenListLoading: false,
        error: action.payload,
      };

    case SYSTEM_NOTIFICATION_INTERNAL_SEND:
      return {
        ...state,
        systemNotificationInternalSend: action.payload,
        systemNotificationInternalSendLoading: true,
      };
    case SYSTEM_NOTIFICATION_INTERNAL_SEND_SUCCESS:
      return {
        ...state,
        systemNotificationInternalSendLoading: false,
        systemNotificationInternalSend: action.payload,
      };
    case SYSTEM_NOTIFICATION_INTERNAL_SEND_ERROR:
      return {
        ...state,
        systemNotificationInternalSendLoading: false,
        error: action.payload,
      };
    default:
      return { ...state };
  }
};

export default Notification;
